// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"289":"3762dbd3","324":"4e8b2a2e"}[chunkId] + ".css";
};